import { render, staticRenderFns } from "./Step4Confirmation.vue?vue&type=template&id=4a944fa9&scoped=true&"
import script from "./Step4Confirmation.vue?vue&type=script&lang=js&"
export * from "./Step4Confirmation.vue?vue&type=script&lang=js&"
import style0 from "./Step4Confirmation.vue?vue&type=style&index=0&id=4a944fa9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a944fa9",
  null
  
)

export default component.exports